import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_life" }, { title: "menu_sidebar_health_orders", link: "/life/orders" }];

const LifeOrderListing = Loadable({
  loader: () => import("container/life/order/listing"),
  loading() {
    return <Loader />;
  }
});

const LifeOrder = Loadable({
  loader: () => import("container/life/order"),
  loading() {
    return <Loader />;
  }
});

export const LifeOrderRoutes: IRoute[] = [
  {
    path: "/life/orders",
    element: <LifeOrderListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/life/orders/details/:id?",
    element: <LifeOrder />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
